import { LoadingDots } from "PFComponents/loading_dots";
import React from "react";

import InsightsPage from "./insights_page";
import useInsightsPage from "./use_insights_page";

type InsightsController = {
  section: "roles" | "skills" | "platform";
};

const InsightsController = ({ section }: InsightsController) => {
  const initPage = {
    tab: section,
    initialized: false
  };

  const { initialized } = useInsightsPage(initPage) as { initialized: boolean };

  return initialized ? <InsightsPage /> : <LoadingDots />;
};

export default InsightsController;
